import { render, staticRenderFns } from "./BattlegroundsDialog.vue?vue&type=template&id=568830c0&scoped=true"
import script from "./BattlegroundsDialog.vue?vue&type=script&lang=js"
export * from "./BattlegroundsDialog.vue?vue&type=script&lang=js"
import style0 from "./BattlegroundsDialog.vue?vue&type=style&index=0&id=568830c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568830c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568830c0')) {
      api.createRecord('568830c0', component.options)
    } else {
      api.reload('568830c0', component.options)
    }
    module.hot.accept("./BattlegroundsDialog.vue?vue&type=template&id=568830c0&scoped=true", function () {
      api.rerender('568830c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/battleground/components/BattlegroundsDialog.vue"
export default component.exports